<template>
  <v-alert
    v-if="errorMessage"
    v-model="notDismissed"
    class="error-text rounded-lg text-center"
    dismissible
    ><v-row
      ><v-col class="pb-1"><v-icon color="red">mdi-alert-octagon</v-icon></v-col></v-row
    >

    <v-row>
      <v-col class="pt-0">
        <span style="color: red; font-weight: bold">{{
          $t("mediaObject.errorUploading")
        }}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col>{{ errorMessage }}</v-col>
    </v-row>
    <v-row
      ><v-col
        ><span class="black--text">{{
          $t("mediaObject.pleaseTryAgain")
        }}</span></v-col
      ></v-row
    >
  </v-alert>
</template>
<script>
export default {
  props: {
    errorMessage: String,
    loading: Boolean,
  },
  data() {
    return {
      notDismissed: true,
    }
  },
  watch: {
    loading(newValue) {
      if (newValue) {
        this.notDismissed = true
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep button.v-alert__dismissible {
  position: absolute; 
  top: 20px;
  right: 15px;
}
</style>